import { resolveDeliveryTerm } from "./smartFiltersStorage";

const STORAGE_PREFIX = "eplex.selection.deliveryTerm.v1";

/** undefined — сохранённого состояния ещё нет; null — действующий «Любой срок». */
export function loadSelectionDeliveryTerm(requestId: string): number | null | undefined {
  if (!requestId) return undefined;
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}.${requestId}`);
    if (raw === null) return undefined;
    const value: unknown = JSON.parse(raw);
    return value === null ? null : (resolveDeliveryTerm(value) ?? undefined);
  } catch {
    return undefined;
  }
}

export function saveSelectionDeliveryTerm(requestId: string, value: number | null): void {
  if (!requestId) return;
  try {
    localStorage.setItem(`${STORAGE_PREFIX}.${requestId}`, JSON.stringify(resolveDeliveryTerm(value)));
  } catch (error) {
    console.error("Failed to save selection delivery term: ", error);
  }
}

/** Фиксируем и автоматически применённый срок; существующий выбор не перезаписываем. */
export function initializeSelectionDeliveryTerm(
  requestId: string,
  initialTerm: number | null | undefined,
): number | null {
  const saved = loadSelectionDeliveryTerm(requestId);
  if (saved !== undefined) return saved;
  const term = resolveDeliveryTerm(initialTerm);
  saveSelectionDeliveryTerm(requestId, term);
  return term;
}
